import { createToast } from "@mercdev.com/mercurial-ui/overlays";
import { CONSTANTS } from "const";

const wrapIntoDefaultErrorHandler = async (callback: () => void) => {
  try {
    await callback();
  } catch (e) {
    const backendError = e?.responseData?.[0];

    backendError?.description
      ? createToast({
          text: backendError.description,
          color: "negative",
        })
      : createToast({
          text: CONSTANTS.GENERAL_ERROR,
          color: "negative",
        });
  }
};

export default wrapIntoDefaultErrorHandler;
